import {
  Avatar,
  Box,
  Card,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectProfile,
  selectProfilePictureBase64,
  selectProfileRole,
} from "../store/profile/selector";
import { protectedRoutes } from "../routes/protected";
import { setPath } from "../store/path/slice";

export function Sidebar({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose(): void;
}) {
  const dispatch = useDispatch();
  const passportState = useSelector(selectProfile);
  const roleState = useSelector(selectProfileRole);
  const profilePicture = useSelector(selectProfilePictureBase64);
  const navigate = useNavigate();
  return (
    <Drawer open={isOpen} onClose={() => onClose()}>
      <Box className="self-center">
        <Card className="flex flex-col gap-4 bg-primary-main m-2 p-3 max-w-72 text-white">
          <Box className="flex gap-2 items-center">
            <Avatar src={profilePicture} />
            <Typography>Login as {roleState?.name}</Typography>
          </Box>
          <Box className="flex flex-col gap-4">
            <Typography className="font-extrabold text-lg">
              {passportState?.title}
            </Typography>
            <Typography className="text-xs">
              {passportState?.department}
            </Typography>
          </Box>
        </Card>
      </Box>
      <Box sx={{ width: 300 }} role="presentation" onClick={() => onClose()}>
        <List>
          {protectedRoutes
            .filter((r) => !r.access || roleState?.access.includes(r.access))
            .map(
              (e) =>
                e.isEnabled && (
                  <ListItem
                    key={e.title}
                    disablePadding
                    className={`${
                      e?.path == window.location.pathname && "bg-violet-300"
                    }`}
                  >
                    <ListItemButton
                      onClick={() => {
                        dispatch(setPath(e.title));
                        navigate(e?.path!);
                      }}
                      className="flex gap-3"
                    >
                      <Typography className="text-primary-main font-extrabold">
                        {e.icon}
                      </Typography>
                      <Typography className="text-primary-main font-bold">
                        {e.title}
                      </Typography>
                    </ListItemButton>
                  </ListItem>
                )
            )}
        </List>
      </Box>
    </Drawer>
  );
}
